import React, { forwardRef, useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import PageHeader from '../../includes/PageHeader';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapInput from '../../../components/ui/TapInput';
import { IAM_API_BASE_URL_2, IAM_REPORT_URL } from '../../../services/TapApiUrls';
import api from '../../../services/api';
import TapSelect from '../../../components/ui/TapSelect';
import { PeriodSelectionWithCustom } from '../../../components/TapUi';
import download from '../../../services/DownloadFile';
import TapHelper from '../../../services/TapHelper';


const CounterlogListingReport               =   forwardRef((props, ref) => {

    let reportKey                           =   'counterlog_listing';

    let initListData                        =   {
        loading                                 :   false,
        data_loaded                             :   false,
        show                                    :   false,
        items                                   :   [],
        page                                    :   1
    };

    let initFormData                       =   {
        show                                    :   false,
        per_page                                :   50,
        form_data_loaded                        :   false,
        loading                                 :   false,
        downloading                             :   false,

        search_transaction_id                   :   '',
        selected_assets                         :   [],
        search_asset_ids                        :   [],
        sites                                   :   [],
        search_site_ids                         :   [],
        
        transaction_delay                       :   null,
        allTransactionDelay                     :   [],
        entry_date_range                        :   '',
        entry_date_range_start                  :   null,
        entry_date_range_end                    :   null,
        date_range                              :   '',
        date_range_start                        :   null,
        date_range_end                          :   null,
        periods                                 :   [],

        search_asset_type_ids                   :   [],
        search_asset_matrix_ids                 :   [],
    };

    let formDataLabel                       =   {
        search_transaction_id                   :   'Transaction ID : ',
        search_site_ids                         :   'Sites : ',
        search_asset_ids                        :   'Assets : ' ,
        date_range                              :   'Transaction Period : ',
        entry_date_range                        :   'Date of Entry : ',
        activity_transaction_delay              :   'Transaction Delay : ',
        search_asset_type_ids                   :   'Asset Type : ',
        search_asset_matrix_ids                 :   'Asset Matrix : ',
    };

    const criteriaRef                       =   useRef();
    const [listData, setListData]           =   useState(initListData);
    const [formData, setFormData]           =   useState(initFormData);
    const [reportDetail, setreportDetail]   =   useState(null);
    const [criteriaHeight, setCriteriaHeight]           =   useState(0)
    const accessToken                       =   useSelector(state => state.auth.access_token);
    const iamAssetType                      =   useSelector(state => state.app.asset_type);
    const iamAssetMatrix                    =   useSelector(state => state.app.asset_matrix);
    const reportListing                     =   useSelector(state => state.app?.report_listing || []);
    const iam_user_sites                    =   useSelector(state => state.app.user_sites || []);
    const all_periods                       =   useSelector(state => state.app.all_periods ? state.app.all_periods: [] );

    let reportUrl                           =   IAM_REPORT_URL + "/counterlog_listing";
  
    const assetTypeOptions                  = (iamAssetType.length > 0
                                                ? iamAssetType.map(at => ({ label: at.asset_type_name, value: at.id }))
                                                : []);
    const assetMatrixOptions                = (iamAssetMatrix.length > 0
                                                ? iamAssetMatrix.map(am => ({ label: am.asset_matrix_unique_id, value: am.id }))
                                                : []);

    const updateCriteriaHeight              = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };

    useEffect(() => {
        setreportDetail(reportListing.find(d => d.key == reportKey));
    }, [reportListing]);

    useEffect(() => {
        updateCriteriaHeight()
    }, [formData.show]);

    useEffect(() => {
        toggleFilterForm();
        loadFormData()
    }, []);
      
    const closeReport                   = () =>  props.history.push('/report');

    const toggleFilterForm              = () =>  {
        setFormData(prev => ({ ...prev, show: true }));
    }

    const submitSearchFormHandler       = (e) =>  {
        e.preventDefault();
        //submit search form and get data listing based on search criteria

        setFormData(prev => ({ ...prev, downloading: true }));
       
        let params = {
            action: "download",
            ...TapHelper.pick(formData, ['search_site_ids', 'search_asset_ids', 'search_transaction_id', 'date_range', 'date_range_start', 'date_range_end', 'entry_date_range', 'entry_date_range_start', 'entry_date_range_end', 'transaction_delay','search_asset_type_ids', 'search_asset_matrix_ids',]),
        };

        api.server2Api.get(reportUrl, {params : params, headers : { 'Authorization': 'Bearer ' + accessToken}  })
            .then((response) => {
                    download.file(null, response.data.msg, response.data.navigation, props)
            }).catch((error) => {}).finally(() => {
                setFormData(pd => ({...pd, downloading : false}));
            });
    }

    const loadFormData                   = () =>  {
        // load any form data if required for filters like site list, asset types, asset matrix etc
        setFormData(pd => ({ ...pd, 
            form_data_loaded        :   true,
            sites               :   iam_user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }),
            periods             :   [...all_periods, { key: 'custom', display: 'Custom Date Range' }],
        }));
        api.server2Api.get(reportUrl, {params : { action: "formData" }, headers : { 'Authorization': 'Bearer ' + accessToken}  })
        .then((response) => {
            let respData = response.data;
            setFormData(pd => ({...pd, 
                form_data_loaded    :   false,
                allTransactionDelay :   respData && respData.transactional_delay ? respData.transactional_delay.map((td) => ({ value: td.key, label: td.text })) : []
            }));
        }).catch((error) => {}).then(() => {
            setFormData(pd => ({...pd, form_data_loaded : false}));
        });
    }

    const filterFormJsx                 = () =>  {
        return <form onSubmit={submitSearchFormHandler} className='py-3'>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Transaction ID</label>
                <div className="col-sm-6">
                    <TapInput
                        name="search_transaction_id"
                        className="form-control form-control-sm"
                        placeholder="Transaction ID"
                        autoComplete="off"
                        value={formData.search_transaction_id}
                        onChange={e => setFormData(d => ({...d, search_transaction_id : e.target.value}))}
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Site Name</label>
                <div className="col-sm-6">
                    <TapSelect
                        changeEvent={o => setFormData(d => ({ ...d, search_site_ids: o.map(e => e.value) }))}
                        placeholder="Select Sites"
                        isClearable={true}
                        options={formData.sites}
                        isSearchable={true}
                        value={formData.sites.filter(s => formData.search_site_ids.includes(s.value))}
                        isMulti={true}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <label className="col-sm-3 col-form-label text-end">Assets</label>
                <div className="col-sm-6">
                    <InputAssetSearch
                        placeholder="Search Assets"
                        filter={true}
                        isMulti={true}
                        value={formData.selected_assets ? [...formData.selected_assets] : []}
                        changeEvent={(so) => {
                            setFormData(d => ({
                                ...d,
                                search_asset_ids: so ? so.map(s => s.value) : [],
                                selected_assets: so && so.length > 0 ? so.map(a => { a.label = a.display_label; return a; }) : []
                            }));
                        }} />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={assetTypeOptions}
                        changeEvent={(selectedOption) => {
                            setFormData(prev => ({
                                ...prev,
                                search_asset_type_ids: selectedOption ? selectedOption.map(opt => opt.value) : []
                            }));
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={assetTypeOptions.filter(s => formData.search_asset_type_ids.includes(s.value))}
                        placeholder="Select Asset Type"
                    />
                </div>
            </div>
            
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Asset Matrix</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={assetMatrixOptions}
                        changeEvent={(selectedOption) => {
                            setFormData(prev => ({
                                ...prev,
                                search_asset_matrix_ids: selectedOption ? selectedOption.map(opt => opt.value) : []
                            }));
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={assetMatrixOptions.filter(s => formData.search_asset_matrix_ids.includes(s.value))}
                        placeholder="Select Asset Matrix"
                    />
                </div>
            </div>
            
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Transaction Delay</label>
                <div className="col-sm-6">
                    <TapSelect
                        isSearchable={false}
                        isClearable={true}
                        isMulti={false}
                        options={formData.allTransactionDelay}
                        value={formData.allTransactionDelay.find(s => formData.transaction_delay == s.value)}
                        changeEvent={o => setFormData(d => ({...d, transaction_delay : o ? o.value : null}))}
                        placeholder="Select Transaction Delay"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Date of Entry</label>
                <div className="col-sm-6">
                    <PeriodSelectionWithCustom
                        periods={formData && formData.periods ? formData.periods : []}
                        value={formData.entry_date_range}
                        startDate={formData.entry_date_range_start}
                        endDate={formData.entry_date_range_end}
                        onSelectPeriod={(period, startDate, endDate) => {
                            setFormData({
                                ...formData, entry_date_range: period, entry_date_range_start: startDate, entry_date_range_end: endDate
                            })
                        }}
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Transaction Period</label>
                <div className="col-sm-6">
                    <PeriodSelectionWithCustom
                        periods={formData && formData.periods ? formData.periods : []}
                        value={formData.date_range}
                        startDate={formData.date_range_start}
                        endDate={formData.date_range_end}
                        onSelectPeriod={(period, startDate, endDate) => {
                            setFormData({
                                ...formData, date_range: period, date_range_start: startDate, date_range_end: endDate
                            })
                        }}
                    />
                </div>
            </div>
            <div className="row my-4  border-bottom">
                <div className="pb-3 col-sm-9 text-end">
                    <div className='d-flex justify-content-end align-items-center gap-2'>
                        <button type="submit" className="btn btn-primary px-4" disabled={formData.loading || formData.downloading}>Download Report {formData.downloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" /> }</button>
                    </div>
                </div>
            </div>
        </form>
    }

    const dataListingJsx              = () =>  {
        return <div className="p-3">
            Data listing goes here
        </div>
    }

    const topRightHeaderJsx             = () =>  {
        return <>
            <div className="text-end mt-2">
                <button type="button"  className="btn btn-secondary" onClick={closeReport}>
                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
                </button>
            </div>
        </>
    }

    return <ApplicationLayout>
        <PageHeader title={reportDetail?.name} name={reportDetail?.name} rightTopHeadingJsx={topRightHeaderJsx()}/>
        <div className="container-fluid pl5">
            <div className="page_containt row">
                <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                    <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide' ].join(" ")} >
                        {formData.loading ? <Loader /> : filterFormJsx()}
                    </div>
                    {/* {formData.show && dataListingJsx()} */}
                </div>
            </div>
        </div>
    </ApplicationLayout>

});

export default CounterlogListingReport;